if (!customElements.get('lumaysa-newsletter')) {
  customElements.define('lumaysa-newsletter', class extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      if (!dialog || this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('.lm-close,.lm-dismiss').forEach(b=>b.addEventListener('click',()=>dialog.close()));
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{try{localStorage.setItem('lumaysa-newsletter-dismissed',Date.now().toString());}catch{}});
      if(window.Shopify?.designMode) return;
      let dismissed=false;
      try{dismissed=Date.now()-Number(localStorage.getItem('lumaysa-newsletter-dismissed')||0)<7*86400000;}catch{}
      if(!dismissed&&!location.search.includes('customer_posted'))this.timer=setTimeout(()=>{if(!document.querySelector('dialog[open],details[open]'))dialog.showModal();},Number(this.dataset.delay)*1000);
    }
    disconnectedCallback(){clearTimeout(this.timer);}
  });
}
